import { useTranslation } from 'react-i18next';
import { Chip } from '@/shared/ui/chips/Chip';

export type ParcelStatus = 'DRAFT' | 'PENDING' | 'APPROVED' | 'REJECTED';

type Props = {
  status: ParcelStatus;
  className?: string;
};

const STATUS_STYLES: Record<ParcelStatus, string> = {
  DRAFT: 'bg-slate-100 text-slate-700 border-slate-200',
  PENDING: 'bg-amber-100 text-amber-800 border-amber-200',
  APPROVED: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  REJECTED: 'bg-red-100 text-red-800 border-red-200',
};

export const StatusChip = ({ status, className }: Props) => {
  const { t } = useTranslation();
  return (
    <Chip tone={STATUS_STYLES[status]} className={className}>
      {t(`parcelStatus.${status}`)}
    </Chip>
  );
};
